import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from "../../environments/environment";

export interface LegalNotice {
  id: number;
  nombre: string;
  url: string;
  tipo: string;
  fecha: string;
  estado: boolean;
  orden: number;
}

@Injectable({
  providedIn: 'root'
})
export class LegalNoticesService {
  private readonly apiUrl = environment.apiUrl;

  constructor(private readonly http: HttpClient) { }

  getLegalNotices(): Observable<LegalNotice[]> {
    return this.http.get<LegalNotice[]>(this.apiUrl+'/documentos/bases-legales');
  }

  getGanadores(): Observable<LegalNotice[]> {
    return this.http.get<LegalNotice[]>(this.apiUrl+'/documentos/ganadores');
  }

  getEstadosFinancieros(): Observable<LegalNotice[]> {
    return this.http.get<LegalNotice[]>(this.apiUrl+"/documentos/estados-financieros");
  }

  getJuntasAccionistas(): Observable<LegalNotice[]> {
    return this.http.get<LegalNotice[]>(this.apiUrl+"/documentos/junta-accionistas");
  }
  

  getMemorias(): Observable<LegalNotice[]> {
    return this.http.get<LegalNotice[]>(this.apiUrl+"/documentos/memorias");
  }

  getCodigoConducta(): Observable<LegalNotice> {
    return this.http.get<LegalNotice>(this.apiUrl+"/documentos/codigo-conducta");
  }

  getHechosEscenciales(): Observable<LegalNotice> {
    return this.http.get<LegalNotice>(this.apiUrl+"/documentos/hechos-escenciales");
  }

  getReporteOperacionales(): Observable<LegalNotice[]> {
    return this.http.get<LegalNotice[]>(this.apiUrl+"/documentos/reportes-operacionales");
  }

  getTerminosYCondiciones(): Observable<LegalNotice[]> {
    return this.http.get<LegalNotice[]>(this.apiUrl+"/documentos/terminos-y-condiciones");
  }

  downloadDocument(url: string): void {
    window.open(url, '_blank');
  }
}
